import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { useChannelQuery } from "../services/websocketApi.ts";

export default function ToastProvider({ children }) {
  const toast = useRef(null);
  const { data, isLoading } = useChannelQuery("toasts");
  const shownIds = useRef(new Set());

  useEffect(() => {
    if (!isLoading && data) {
      data.messages
          .filter((msg) => msg._id)
          .forEach((msg) => {
            if (!shownIds.current.has(msg._id)) {
              shownIds.current.add(msg._id);
              toast.current.show({
                severity: msg.severity || "info",
                summary: msg.author || "Unknown author",
                detail: msg.message || "No message",
                life: 5000,
              });
            }
          });
    }
  }, [data, isLoading]);

  return (
      <>
        {children}
        <Toast ref={toast} position="top-right" />
      </>
  );
}
